import React, { useState, useRef, useEffect } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './LocationDetails.scss';
import accessLocation from '../../../../../../assests/access-location.svg';
import location from '../../../../../../assests/location.svg';
import Modal from 'b2b-ui-components-lib/lib/components/modal';
import WidgetPopup from '../WidgetPopup/WidgetPopup';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import useStateWithCb from 'home/components/customHook/useStateWithCb';
import { createUpdateUnauthLead, getFromSessionStorage, setInSessionStorage, trackAnalytics, transformFeasibilityResponse } from 'common/utils/app.utils';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { FEASIBILITY_RESPONSE, MODULE_ID } from 'home/common/constants/constants';
import WidgetContainer from '../WidgetContainer/WidgetContainer';
// mocked feasibility response
import mockedFeasibilityRes from './mock.json';

const LocationDetails = (props) => {
  const { isdedicatedJourney, showNotification, updateActiveIndex, showLoader, editButtonClick, setUserFilledPincode, location, toggelNotification } = props;

  const requestedBandwidth = location?.state?.bandwidth; // user selected bandwidth on landing page

  const [show, setShow] = useState(false);
  const [showWidgetPopup, setsShowWidgetPopup] = useState(false);
  const [allowLocationToWidget, setAllowLocationToWidget] = useStateWithCb(false);
  const [geoLoader, setGeoLoader] = useState(false);

  const leadData = getCurrentLead?.();
  const widgetFrameRef = useRef(null);

  useEffect(() => {
    toggelNotification();
    let getFeasibilityResponse=getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE)
    trackAnalytics({
      eVar0: 'b2b| dedicated internet| home page| feasibility| location access',
      prop0: 'b2b| dedicated internet',
      prop14: leadData?.authorizedSignatory?.phoneNumber,
      prop35: leadData?.authorizedSignatory?.companyName,
      prop15: leadData?.authorizedSignatory?.email,
      prop17: leadData?.authorizedSignatory?.firstName,
      eVar5:  getFeasibilityResponse?.feasibilityId ? 'ql_lead_created':'uql_lead_created',
    });
  }, []);

  const onSuccess = ({ coords }) => {
    const currentLatitude = coords?.latitude;
    setGeoLoader(false);

    if (currentLatitude) {
      setAllowLocationToWidget(true, (_prevValue, _newValue) => {
        setsShowWidgetPopup(true);
      });
    }
  };

  const onError = (error) => {
    // const errorMessage = error.message;
    const errorMessage = 'Allow location permission from your device settings and try again';
    setGeoLoader(false);
    showNotification(true, errorMessage, NOTIFICATION_TYPE.ERROR);
  };

  const allowLocationAccess = () => {
    const isPopupBlocked = ('' + window?.open)?.indexOf('[native code]') === -1;
    const geo = navigator?.geolocation;

    if (isPopupBlocked) {
      const errorMessage = 'Popup Blocker is enabled! Please add this site to your exception list.';

      showNotification(true, errorMessage, NOTIFICATION_TYPE.ERROR);
      return false;
    }

    if (!geo) {
      const errorMessage = 'Geolocation is not enabled! Please add this site to your exception list.';

      showNotification(true, errorMessage, NOTIFICATION_TYPE.ERROR);
      return false;
    }

    setGeoLoader(true);
    geo?.getCurrentPosition(onSuccess, onError);

    //   const watcher = geo.watchPosition(onChange, onError);
    //   return () => geo.clearWatch(watcher);
  };

  const handleWidgetPopupClose = () => {
    // let log = {
    // 	data: {
    // 		eventName: loggingEventName.OMNIWIDGET_POPUP_CLOSE_CLICKED
    // 	},
    // };
    // sendLogData(log);
    setsShowWidgetPopup(false);
  };
  const handleWidgetManually = () => {
    // let log = {
    // 	data: {
    // 		eventName: loggingEventName.OMNIWIDGET_POPUP_CLOSE_CLICKED
    // 	},
    // };
    // sendLogData(log);
    setAllowLocationToWidget(false, (_prevValue, _newValue) => {
      setsShowWidgetPopup(true);
    });
  };

  const handleAddressSubmit = (widgetCbData) => {
    const feasibilityResponse = widgetCbData?.data;

    // mock data
    // const feasibilityResponse = JSON.parse(JSON.stringify(mockedFeasibilityRes));

    if (feasibilityResponse) {
      setInSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE, feasibilityResponse);
    }
  };

  const handleUpdateLead = (widgetCbData) => {
    const feasibilityResponse = widgetCbData?.feasibilityResponse;
    const userFilledPincode = widgetCbData?.pinCode;

    // mock data
    // const feasibilityResponse = JSON.parse(JSON.stringify(mockedFeasibilityRes));

    if (feasibilityResponse) {
      setInSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE, feasibilityResponse);
      setUserFilledPincode(userFilledPincode);
      const payload = transformFeasibilityResponse(feasibilityResponse, leadData, userFilledPincode);
      const successCb = () => updateActiveIndex(3);
      const extraArgs = {
        setLoader: showLoader,
        showNotification
      };

      createUpdateUnauthLead(payload, isdedicatedJourney, successCb, extraArgs);
    }
  };

  const handleWidgetSubmitClick = (widgetCbData) => {
    handleUpdateLead(widgetCbData);
  };

  const body = (
    <div className="body_section">
      <div className="text">
        <img src={location} alt="Location" />
        <p>Airtel Business wants to use your location</p>
      </div>
    </div>
  );

  const footer = (
    <div className="footer_section">
      <div className="btn_action_location">
        <Button displayName="Block" variant="transparentbtn" onClick={() => setShow(false)} />
        <Button
          displayName="Allow"
          variant="transparentbtn"
          onClick={() => {
            setShow(false);
            allowLocationAccess();
          }}
        />
      </div>
    </div>
  );

  return (
    <div className="location_details">
      <WidgetContainer
        onCityChange={() => {}}
        onFeasibilityReset={handleAddressSubmit}
        onAddressSubmit={handleWidgetSubmitClick}
        onSubmit={handleWidgetSubmitClick}
        requestedBandwidth={requestedBandwidth ?? `10Mbps`}
      />
      {/* <img src={accessLocation} alt="Access Location" />
      <h3 className="location_head">What’s your location?</h3>
      <p className="sub_text">We need your location to confirm serviceability of your fiber connection</p>
      <Button onClick={allowLocationAccess} buttonClass="location_btn" disabled={geoLoader}>
        Allow Location Access
        {geoLoader && <span className="loading_icon"></span>}
      </Button>

      {show ? <Modal body={body} footer={footer} /> : ''}

      <div className="address_text_container">
        <span className="address_text" onClick={handleWidgetManually}>
          Enter Address Manually
        </span>
      </div> */}
      {/* <iframe width={'100%'} height={'600px'} allow='geolocation *' id='test-widget' ref={widgetFrameRef} src="http://localhost:8000/?lob=BROADBAND&pageName=SAFO_LEAD_PAGE&requestorSource=DCAT_APP"></iframe> */}
      {/* <WidgetPopup
        onCityChange={() => {}}
        isOpen={showWidgetPopup}
        isLocationAllowed={allowLocationToWidget}
        onPopupClose={handleWidgetPopupClose}
        onAddressSubmit={handleAddressSubmit}
        onSubmit={handleWidgetSubmitClick}
        editButtonClick={editButtonClick}
        // selectedCity={'Delhi'}
      /> */}
    </div>
  );
};

export default LocationDetails;
